import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/wh-support-docs/wh-support-docs/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Cúram by Merative 8.2.1.0`}</h2>
    <p>{`Cúram by Merative™  is a leading solution for supporting the end-to-end social program and care coordination service delivery process. V8.2.1.0 includes enhancements to our technical infrastructure and user experience.`}</p>
    <h3>{`Technical Infrastructure`}</h3>
    <h4>{`Support for Java 21 on WebLogic 14.1.2  `}</h4>
    <p>{`In advance of Oracle ending support for Java 8 in Dec 2030, Cúram is enhancing our solution to support Java 21`}</p>
    <ul>
      <li parentName="ul">{`In `}<strong parentName="li">{`v8.2.0.0`}</strong>{`, we introduced support for Java 21 for IBM Liberty  application server using IBM MQ for containerised deployments. `}</li>
      <li parentName="ul">{`Now, with `}<strong parentName="li">{`v8.2.1.0`}</strong>{`, we have extended Java 21 support to include WebLogic application server, upgrading to WLS 14.1.2.
We continue to support Java 8 on WebSphere application server, Liberty and WebLogic and encourage customers to make plans to transition to modern java.`}</li>
    </ul>
    <h4>{`Extending support for Containerisation`}</h4>
    <p>{`With the `}<strong parentName="p">{`8.2.1.0 Modern Java release`}</strong>{`, we’ve further expanded our container orchestration platform support. `}</p>
    <ul>
      <li parentName="ul">{`Starting `}<strong parentName="li">{`v7.0.11`}</strong>{` Curam introduced container support for `}<strong parentName="li">{`OpenShift`}</strong>{`. `}</li>
      <li parentName="ul">{`In `}<strong parentName="li">{`v8.2.0.0`}</strong>{`, we introduced support for `}<strong parentName="li">{`Microsoft Azure Kubernetes Service (AKS)`}</strong>{`. `}</li>
      <li parentName="ul">{`Now, with `}<strong parentName="li">{`v8.2.1.0`}</strong>{`, we’re adding support for `}<strong parentName="li">{`Amazon Elastic Kubernetes Service (EKS)`}</strong>{`.
This enhancement provides greater flexibility and choice for deploying Curam in modern containerized environments. `}</li>
    </ul>
    <h3>{`User Experience`}</h3>
    <h4>{`New Enhancements to Streamline Eligibility and Entitlement Processing`}</h4>
    <p>{`We’re excited to announce two key improvements designed to make workflows more efficient for customers managing multiple benefit programs: `}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Evidence Management at Application Case`}</strong>{` - Allows caseworker to decide whether specific evidence changes should be activated together, once, or separately providing control to streamline the process when appropriate. `}</p>
      </li>
      <li parentName="ul">
        <p parentName="li"><strong parentName="p">{`Verification Proof Sharing`}</strong>{` - We’ve introduced `}<strong parentName="p">{`automation`}</strong>{` to streamline the sharing of verification documentation.  When adding `}<strong parentName="p">{`Verification Proof`}</strong>{` to an active evidence record, you can now configure Curam to `}<strong parentName="p">{`automatically share`}</strong>{` the corresponding verification documentation to other cases.
This means less manual work and faster sharing of critical proof, simplifies caseworker experience and improves accuracy for Health and Human Services organizations. `}</p>
      </li>
    </ul>
    <h4>{`Task and Notification documentation `}</h4>
    <p>{`Documentation on the business processes in Platform and Insurance Affordability that trigger Tasks and Notifications is now available from the  Knowledge Base section of the support portal.`}<br parentName="p"></br>{`
`}{`This provides customers with the information they need to decide which Tasks and Notifications they want to retain to best suit their requirements. `}</p>
    <h4>{`Accessibility – Caseworker and Clients`}</h4>
    <p>{`Cúram is compliant with WCAG 2.1 level AA with exceptions. The 8.2.1.0 release continues our commitment to ensuring our systems meet recognized industry accessibility standards with additional enhancements across numerous WCAG 2.1 criteria to improve accessibility for both clients and caseworkers.  `}</p>
    <p>{`For more details about these features, see the `}<a parentName="p" {...{
        "href": "/wh-support-docs/pdf/spm/Curam_WhatsNew_821.pdf"
      }}>{`What’s new in 8.2.1.0`}</a>{` and the `}<a parentName="p" {...{
        "href": "/wh-support-docs/pdf/releasenotes/curam8210.pdf"
      }}>{`8.2.1.0 release notes`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      